import React from 'react';
import AboutOne from '../../components/About/AboutOne';
import CounterOne from '../../components/About/CounterOne';
import videoImg from '../../assets/images/resources/counter-one-img-1.jpg';
import WhyAreWe from '../../components/About/WhyAreWe';
import image1 from '../../assets/images/resources/why-are-we-img-1.jpg';
import image2 from '../../assets/images/resources/why-are-we-img-2.jpg';
import TestimonialsSection from '../../components/About/TestimonialsSection';

const AboutMain = () => {
    const counters = [
        { iconClass: 'icon-schedule', end: 100, suffix: '+', text: 'Our Happy Students' },
        { iconClass: 'icon-schedule', end: 50, suffix: '+', text: 'Expert Faculty Members' },
        { iconClass: 'icon-schedule', end: 10, suffix: '+', text: 'State-of-the-Art Studios' }
    ];
    const points = [
        {
            iconClass: 'why-are-we__icon',
            arrowIcon: 'icon-arrow-down-left',
            icon: 'icon-location why-are-we__location',
            heading: 'World-Class Infrastructure',
            text: 'Modern architecture and state-of-the-art facilities for immersive learning.'
        },
        {
            iconClass: 'why-are-we__icon-2',
            arrowIcon: 'icon-arrow-down-right',
            icon: 'icon-shopping-cart why-are-we__cart',
            heading: 'Expert Mentorship',
            text: 'Guidance from industry leaders and seasoned professionals.'
        },
        {
            iconClass: '',
            arrowIcon: '',
            icon: 'icon-call why-are-we__call',
            heading: 'Hands-On Training',
            text: 'Real-world projects and practical exposure from day one.'
        }
    ];

    return (
        <React.Fragment>
            <AboutOne />
            <CounterOne
                imageSrc={videoImg}
                videoId="1QGaxcefTTw" // YouTube video ID
                videoCaption="Watch our video"
                tagline="Our Vision"
                title="Where dreams and stories come alive"
                description="Sunrising Cinevision stands as a beacon of opportunity, creativity, and innovation. Join us to shape the future of storytelling."
                counters={counters}
            />
            <TestimonialsSection/>
            <WhyAreWe
                imageSrc1={image1}
                imageSrc2={image2}
                tagline="Why Choose Us"
                title="Empowering Creativity and Innovation in Filmmaking"
                points={points}
                year="Since 2020"
                yearDescription="Dedicated to nurturing talent and shaping future stars in the entertainment industry."
            />
        </React.Fragment>
    );
};

export default AboutMain;
